import styled from "styled-components";

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

export const LoadingSpinnerLogo = styled.img`
  width: "42px";

  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const SpinnerText = styled.span`
  color: #002244;
  font-size: 14px;
  font-weight: 600;
`;
